var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0B152",
    d: "M10 9.167a.833.833 0 0 0-.833.833v3.334a.833.833 0 0 0 1.666 0V10A.833.833 0 0 0 10 9.167Zm.316-3.267a.833.833 0 0 0-.633 0 .833.833 0 0 0-.275.175.959.959 0 0 0-.175.275.833.833 0 0 0 .175.908.959.959 0 0 0 .275.176.833.833 0 0 0 1.15-.767.875.875 0 0 0-.242-.592.833.833 0 0 0-.274-.175ZM10 1.667a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667Zm0 15a6.667 6.667 0 1 1 0-13.334 6.667 6.667 0 0 1 0 13.334Z"
  })));
};
export default SvgWarning;